module.exports = __webpack_public_path__ + "img/erweima.8044b413.png";